module.exports = __webpack_public_path__ + "img/image-upload-black.15368c73.png";